document.addEventListener('DOMContentLoaded', () => {

  /* =====================
     CARRUSELES
  ===================== */

  document
    .querySelectorAll('.c29-carousel-wrapper')
    .forEach(wrapper => {

      const carousel =
        wrapper.querySelector('[data-c29-carousel]');

      const prev =
        wrapper.querySelector('.c29-carousel-prev');

      const next =
        wrapper.querySelector('.c29-carousel-next');

      if (!carousel) return;


      function move(direction) {

        const card =
          carousel.querySelector('.c29-product-card');

        if (!card) return;

        const styles =
          window.getComputedStyle(carousel);

        const gap =
          parseFloat(styles.columnGap) || 0;

        const amount =
          card.getBoundingClientRect().width + gap;

        carousel.scrollBy({
          left: direction * amount,
          behavior: 'smooth'
        });

      }


      prev?.addEventListener(
        'click',
        () => move(-1)
      );


      next?.addEventListener(
        'click',
        () => move(1)
      );

    });


  /* =====================
     MENÚ MÓVIL
  ===================== */

  const menu =
    document.querySelector(
      '[data-c29-mobile-menu]'
    );

  const openButton =
    document.querySelector(
      '[data-c29-menu-open]'
    );


  const closeButtons =
    document.querySelectorAll(
      '[data-c29-menu-close]'
    );


  function openMenu() {

    if (!menu) return;

    menu.classList.add('is-open');

    document.body.style.overflow = 'hidden';

  }


  function closeMenu() {

    if (!menu) return;

    menu.classList.remove('is-open');

    document.body.style.overflow = '';

  }


  openButton?.addEventListener(
    'click',
    openMenu
  );


  closeButtons.forEach(button => {

    button.addEventListener(
      'click',
      closeMenu
    );

  });


  document.addEventListener(
    'keydown',
    event => {

      if (event.key === 'Escape') {
        closeMenu();
      }

    }
  );

});